import appRoutes from './appRoutes';
import dashboardRoutes from './dashboardRoutes';


export const routes = {
    appRoutes,
    dashboardRoutes
}